"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var routeFileWatch_exports = {};
__export(routeFileWatch_exports, {
  isPathInsideDirectory: () => isPathInsideDirectory,
  isRouteFilePath: () => isRouteFilePath,
  isRouteFileWatchEvent: () => isRouteFileWatchEvent
});
module.exports = __toCommonJS(routeFileWatch_exports);
var import_path = __toESM(require("path"), 1);
var routeFileExtensionRe = /\.[jt]sx?$/;
function isRouteFilePath(filePath) {
  return routeFileExtensionRe.test(filePath) && !filePath.endsWith(".d.ts");
}
function isPathInsideDirectory(filePath, directory) {
  var relativePath = import_path.default.relative(import_path.default.resolve(directory), import_path.default.resolve(filePath));
  return relativePath !== "" && !relativePath.startsWith("..") && !import_path.default.isAbsolute(relativePath);
}
function isRouteFileWatchEvent(param) {
  var { event, filePath, routerRoot, includeChangeEvents = false } = param;
  var isRouteFileEvent = event === "add" || event === "delete" || event === "unlink" || includeChangeEvents && event === "change";
  return isRouteFileEvent && isPathInsideDirectory(filePath, routerRoot) && isRouteFilePath(filePath);
}
//# sourceMappingURL=routeFileWatch.js.map
